export default __webpack_public_path__ + "static/media/CRLonsdale.a4ef0a46.png";